(() => {
  const config = window.napaWinkPreviewMode;
  if (!config || !config.enabled) return;

  const checkoutControlSelector = [
    '[name="checkout"]',
    '#checkout',
    '#CartDrawer-Checkout',
    '.cart__checkout-button',
    '.shopify-payment-button',
    '[data-shopify="payment-button"]',
    'shopify-accelerated-checkout',
    'shopify-accelerated-checkout-cart',
  ].join(',');
  let noticeTimer;

  const isCheckoutUrl = (value) => {
    if (!value) return false;

    try {
      const url = new URL(value, window.location.href);
      return /\/checkouts?(?:\/|$)/i.test(url.pathname);
    } catch (_error) {
      return /\/checkouts?(?:[/?#]|$)/i.test(value);
    }
  };

  const announceBlockedCheckout = () => {
    let notice = document.getElementById('NapaWinkPreviewModeNotice');

    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'NapaWinkPreviewModeNotice';
      notice.className = 'nw-preview-mode__toast';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      document.body.appendChild(notice);
    }

    notice.textContent = config.message;
    notice.hidden = false;
    window.clearTimeout(noticeTimer);
    noticeTimer = window.setTimeout(() => {
      notice.hidden = true;
    }, 5000);
  };

  const blockEvent = (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    announceBlockedCheckout();
  };

  const eventTargetsCheckout = (event) =>
    event.composedPath().some((node) => {
      if (!(node instanceof Element)) return false;
      if (node.matches(checkoutControlSelector)) return true;
      return node instanceof HTMLAnchorElement && isCheckoutUrl(node.href);
    });

  const disableCheckoutElement = (element) => {
    if (!(element instanceof Element)) return;

    if (element.matches('button[name="checkout"], input[name="checkout"]')) {
      element.removeAttribute('name');
      element.setAttribute('disabled', 'disabled');
    }

    if (element.matches(checkoutControlSelector)) {
      element.setAttribute('aria-disabled', 'true');
    }

    if (element instanceof HTMLAnchorElement && isCheckoutUrl(element.href)) {
      element.setAttribute('aria-disabled', 'true');
      element.removeAttribute('href');
    }
  };

  const disableInjectedCheckout = (root) => {
    if (!(root instanceof Element) && root !== document) return;

    if (root instanceof Element) disableCheckoutElement(root);
    root.querySelectorAll(`${checkoutControlSelector}, a[href]`).forEach(disableCheckoutElement);
  };

  document.addEventListener(
    'click',
    (event) => {
      if (eventTargetsCheckout(event)) blockEvent(event);
    },
    true
  );

  document.addEventListener(
    'auxclick',
    (event) => {
      if (eventTargetsCheckout(event)) blockEvent(event);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const submitter = event.submitter;
      if (
        isCheckoutUrl(form.action) ||
        (submitter instanceof Element && submitter.matches(checkoutControlSelector)) ||
        form.querySelector('[name="checkout"]')
      ) {
        blockEvent(event);
      }
    },
    true
  );

  disableInjectedCheckout(document);

  new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach(disableInjectedCheckout);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
